const { drawCube } = require('./cube');
const { drawPyram } = require('./pyram');
const { drawMegaminxLL } = require('./minx-ll');

module.exports = { drawCube, drawPyram, drawMegaminxLL };
